module.exports = __webpack_public_path__ + "static/img/10.94da364.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news8/10.jpg
// module id = kzfI
// module chunks = 1